import * as net from 'util/Net';

export function runAlphaFold(proteinId: string): Promise<void> {
  return net.postJSONPromise({url: '/1/api/proteins:alphafold', data: {proteinId}});
}
